import React from 'react';
import { components, GroupBase, NoticeProps } from 'react-select';
import * as Colors from '../../../constants/Colors';
import { Text } from '../../../typography/Text';

export type NoOptionsMessageProps<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = NoticeProps<Option, IsMulti, Group>;

export const NoOptionsMessage = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    children,
    ...props
}: NoOptionsMessageProps<Option, IsMulti, Group>) => (
    <components.NoOptionsMessage {...props}>{children}</components.NoOptionsMessage>
);

export const DefaultNoOptionsMessage = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(
    props: NoOptionsMessageProps<Option, IsMulti, Group>
) => (
    <components.NoOptionsMessage {...props}>
        <Text textSize="large" textColor={Colors.grey} margin="8px 12px">
            No options
        </Text>
    </components.NoOptionsMessage>
);
